export default Object.freeze({
  ENDPOINT: "https://api.rockliffehall.com",
  WWWENDPOINT: "/umbraco/api/account",
  IDENTITYENDPOINT: "https://identity.rockliffehall.com",
  ACCESSTOKENURI: "connect/token",
  AUTHORIZATIONURL: "connect/authorize",
});
